import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { UserBonus } from 'config/types/bonus/userBonus'
import { Trans } from 'react-i18next'
import { formatDisplayDate } from 'utils/dateHelper'
import { BonusContentFieldTitle, BonusContentGridSystem } from '../styled'

const BonusContentExpiryDate: React.FC<{ bonus: UserBonus } & BoxProps> = ({ bonus, ...props }) => {
  return (
    <BonusContentGridSystem {...props}>
      <BonusContentFieldTitle>
        <Trans>Valid until</Trans>
      </BonusContentFieldTitle>
      <Text fontWeight={600} fontSize="12px" lineHeight="normal" color="textTertiary">
        {formatDisplayDate(new Date(bonus.condition.expiryDate))}
      </Text>
    </BonusContentGridSystem>
  )
}

export default BonusContentExpiryDate
